import React from 'react';
import { Row, FormControl } from 'react-bootstrap';
import _ from 'lodash';

import CheckboxInput from '../../../components/CheckboxInput/CheckboxInput';
import InputCollection from '../../../components/InputCollection/InputCollection';

function Recipients({
    feeRecipientTypes,
    formData,
    formChanged,
    formValidationCheck,
    isBusy
}) {
    return (
        <>
            <Row>
                <div className="col-md-12 mt-1">
                    <div style={{ borderBottom: '1px solid #b7b7bd', marginBottom: '20px' }}>
                        <h4><strong>Recipients</strong></h4>
                    </div>
                </div>
            </Row>

            <Row>
                <div className="col-md-3">
                    <InputCollection labelText="Fee Recipient" errorMessage={formValidationCheck('feeRecipientTypeId')}>
                        {_.isEmpty(feeRecipientTypes) ? (
                            formData.feeRecipientTypeName ? (
                                <FormControl
                                    type="text"
                                    disabled
                                    value={formData.feeRecipientTypeName}
                                />
                            ) : <div className="skeleton skeleton-select" />
                        ) : (
                            <FormControl
                                id="feeRecipientTypeId"
                                componentClass="select"
                                value={formData.feeRecipientTypeId || ''}
                                onChange={(event) => formChanged(event.target.id, event.target.value)}
                                disabled={isBusy}
                            >
                                {feeRecipientTypes}
                            </FormControl>
                        )}
                    </InputCollection>
                </div>
                <div className="col-md-3 recipients-checkbox">
                    <CheckboxInput
                        id="excludeTeamLead"
                        value={formData.excludeTeamLead}
                        labelText="Exclude Team Lead"
                        changed={(id, value) => formChanged(id, !value)}
                        disabled={isBusy}
                    />
                </div>
                <div className="col-md-3 recipients-checkbox">
                    <CheckboxInput
                        id="excludeMentor"
                        value={formData.excludeMentor}
                        labelText="Exclude Mentor"
                        changed={(id, value) => formChanged(id, !value)}
                        disabled={isBusy}
                    />
                </div>
                <div className="col-md-3 recipients-checkbox">
                    <CheckboxInput
                        id="excludeTransactionCoordinator"
                        value={formData.excludeTransactionCoordinator}
                        labelText="Exclude Transaction Coordinator"
                        changed={(id, value) => formChanged(id, !value)}
                        disabled={isBusy}
                    />
                </div>
            </Row>
        </>
    );
}

export default Recipients;